import { Component, EventEmitter, inject, Input, input, Output } from '@angular/core';
import { RealEstate } from '../../models/real-estate.model';
import { Router } from '@angular/router';
import { Plans } from '../../shared/constants/plan.constants';
import { Statuses } from '../../shared/constants/status.constants';

@Component({
  selector: 'app-property-map-item',
  standalone: false,
  templateUrl: './property-map-item.component.html',
  styleUrl: './property-map-item.component.scss',
})
export class PropertyMapItemComponent {
  @Input() property!: RealEstate;
  listId = input<string>('propertyItem');

  @Output() close = new EventEmitter<void>();

  private router = inject(Router);

  statuses = Statuses;
  plans = Plans;

  goToDetails(propertyId: number): void {
    this.router.navigate(['/properties', propertyId]);
  }

  onClose(event: MouseEvent): void {
    event.stopPropagation();
    this.close.emit();
  }

  isSponsered(): boolean {
    return this.property.isSponsered && new Date(this.property.sponseredExpireDate) > new Date();
  }
}
